import Decimal from 'decimal.js';
import { utils } from "../../../../utils";
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export const renderRangeDiscountTitle = (discountedPrice, price, hasDiscount, testId) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [discountedPrice.minPrice instanceof Decimal && /*#__PURE__*/_jsxs(_Fragment, {
    children: [utils.formatDollarAmount(discountedPrice.minPrice), ' - ']
  }), discountedPrice.minPrice == null && 'Up to ', discountedPrice.maxPrice instanceof Decimal ? utils.formatDollarAmount(discountedPrice.maxPrice) : '', price != null && !(price instanceof Decimal) && hasDiscount && /*#__PURE__*/_jsxs(_Fragment, {
    children: [' ', /*#__PURE__*/_jsxs("del", {
      "data-testid": testId,
      children: [price.minPrice instanceof Decimal && /*#__PURE__*/_jsxs(_Fragment, {
        children: [utils.formatDollarAmount(price.minPrice), ' - ']
      }), price.maxPrice instanceof Decimal ? utils.formatDollarAmount(price.maxPrice) : '']
    })]
  })]
});
export const renderDecimalDiscountTitle = (discountedPrice, price, hasDiscount, isVariable, unitName, testId) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [utils.formatDollarAmount(discountedPrice), price instanceof Decimal && hasDiscount && /*#__PURE__*/_jsxs(_Fragment, {
    children: [' ', /*#__PURE__*/_jsx("del", {
      "data-testid": testId,
      children: utils.formatDollarAmount(price)
    })]
  }), isVariable && " / ".concat(unitName)]
});